import { css } from 'glamor'

export default {
  question: css({
    transition: 'opacity .3s',
    opacity: 1,
  }),
  hide: css({
    opacity: 0,
  }),
  questionText: css({
    fontSize: '15px',
    lineHeight: '1.5',
    fontFamily: "'Press Start 2P', cursive",

    '@media(min-width: 530px)': {
      fontSize: '18px',
    },
  }),
}



// WEBPACK FOOTER //
// ./src/components/Question/styles.js